import { render, staticRenderFns } from "./downLoad.vue?vue&type=template&id=724169bc&scoped=true&"
import script from "./downLoad.vue?vue&type=script&lang=js&"
export * from "./downLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724169bc",
  null
  
)

export default component.exports